/*
Copyright 2020 The Matrix.org Foundation C.I.C.

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/

import { TemplateView } from "../general/TemplateView";

export class DownloadView extends TemplateView {
    render(t, vm) {
        return t.div({className: "DownloadScreen"}, [
            t.div({ className: "picture" }),
            t.div({className: "content"}, [
                t.span({ className: "first" },vm.i18n`Use Sending.Me App`),
                t.span({ className: "second" },vm.i18n`Sending me is a Decentralized Instant...`),
            ]),
            t.button({
                className: "OpenButton",
                onClick: () => vm.download(),
            }, vm.i18n`Download`)
        ]);
    }
}
